<template>
  <div class="policy_detail">
    <div class="detail_title">
      {{ infoList.policyName }}
      <span @click="goBack" class="back_btn">返回</span>
    </div>
    <div class="contentInfo" v-html="infoList.policyContent"></div>
    <div class="fileBox" v-if="infoList.fileUrlArr && infoList.fileUrlArr.length > 0">
      <div class="file_label">附件:</div>
      <div class="file_content">
        <span class="file_item" v-for="(item, index) in infoList.fileUrlArr" :key="index">
          附件{{ index + 1 }}：
          <a :href="item">{{ formatFileUrl(item) }}</a>
        </span>
      </div>
    </div>
    <div class="file_origin">发文单位：{{ infoList.theUnits ? infoList.theUnits : '-' }}</div>
    <div class="file_origin">发布日期：{{ infoList.datePosted }}</div>
  </div>
</template>

<script>
import indexApi from '@/api/index'
import { formatFileUrl } from '../../utils/util'

export default {
  name: 'policyDetail',
  data() {
    return {
      infoList: {}
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    goBack() {
      window.history.back(-1)
    },
    formatFileUrl(fileUrl) {
      return formatFileUrl(fileUrl)
    },
    downFile() {
      window.location.href(this.infoList.fileUrl)
    },
    getList() {
      indexApi.policyQueryById({ id: this.$route.query.id ? this.$route.query.id : '' }).then((res) => {
        this.infoList = res.result
      })
    }
  }
}
</script>

<style lang="less" scoped>
.policy_detail {
  padding: 32px 98px;
  position: relative;
  .back_btn {
    cursor: pointer;
    position: absolute;
    top: 50%;
    right: 0;
    padding: 8px 15px;
    transform: translateY(-50%);
    border: 1px solid #999;
    border-radius: 10px;
  }
  .back_btn:hover {
    color: #1492ff;
    border-color: #1492ff;
  }
  .detail_title {
    font-size: 16px;
    font-family: MicrosoftYaHeiUI-Bold, MicrosoftYaHeiUI;
    font-weight: bold;
    color: #333333;
    line-height: 16px;
    text-align: center;
    margin-bottom: 48px;
    position: relative;
  }
  .contentInfo {
    font-size: 14px;
    font-family: MicrosoftYaHeiUI;
    color: #333333;
    line-height: 18px;
    margin-bottom: 72px;
  }
  .fileBox {
    .file_label {
      font-size: 14px;
      color: #333333;
      line-height: 18px;
      margin-bottom: 13px;
    }
    .file_content {
      font-size: 14px;
      font-family: MicrosoftYaHeiUI;
      color: #1492ff;
      line-height: 18px;
      display: flex;
      flex-direction: column;
      .file_item {
        margin-bottom: 8px;
      }
    }
  }
  .file_origin {
    text-align: right;
    font-size: 14px;
    font-family: MicrosoftYaHeiUI;
    color: #333333;
    line-height: 14px;
    margin-top: 8px;
  }
}
</style>
